import Image from 'next/image'
import dynamic from 'next/dynamic'
import Ellipse from '../../public/images/Ellipse 460.png'
import BannerDesk from '../../public/banner-desk-old.jpg'
import BannerDeskEnglish from '../../public/web.png'
import BannerMobile from '../../public/banner-mob-old.jpg'
import BannerMobileEnglish from '../../public/Mobile.png';
import LightLogo from '../../public/images/Blue.png'
import VectorWhite from '../../public/images/Vector-white.png'
import PinkVector from '../../public/images/Vector.png'
import GreenVector from '../../public/images/Vector 1.png'
import FormBoy from '../../public/images/form-boy.png'
import FormGirl from '../../public/images/form-girl.png'
import BookBoy from '../../public/images/book-boy.png'
import BookGirl from '../../public/images/book-girl.png'
import FormHeadingOne from '../../public/images/heading-one.png'
import FormHeadingTwo from '../../public/images/heading-two.png'
import SmallFormVector from '../../public/images/smallFormVector.png'
import MediuFormVector from '../../public/images/mediumFormVector.png'
import LargeFormVector from '../../public/images/largeFormVector.png'
import PersonalizationSection from './Home/PersonalizationSection'
import PersonalizedNotebookBanner from './Home/PersonalizedNotebookBanner'
import Link from 'next/link'
import { useRouter } from 'next/router'
import contactHeading from '../../public/Contact.svg'
import supportHeading from '../../public/Support.svg'

// DYNAMIC IMPORTS HERE : better visualization and enable lazy loading for the components
const MostSoldProducts = dynamic(() => import('./Home/MostSoldProducts'), {
  loading: () => <div className="h-64 bg-gray-100 animate-pulse" />,
  ssr: true
})
const PersonalizedNotebooks = dynamic(() => import('./Home/PersonalizedNotebooks'))
const AgeGroups = dynamic(() => import('./Home/AgeGroups'))
const FeaturedProducts = dynamic(() => import('./Home/FeaturedProducts'))
const FeaturedCategories = dynamic(() => import('./Home/FeaturedCategories'))
const HomeRequestForm = dynamic(() => import('./forms/HomeRequestForm'), {
  loading: () => <div className="h-96 bg-gray-50 animate-pulse" />,
})

interface Props {
  most_sold_products: any
  personalized_notebooks: any
  age_group_options: any
  featured_categories: any
  home: any
  categories: any
}

export default function Home({
  most_sold_products,
  personalized_notebooks,
  age_group_options,
  featured_categories,
  home,
  categories,
}: Props) {
  const slides = home.sliders
  const { locale } = useRouter();

  // Get localized values for HomeRequestForm
  const requestTitle = locale === 'ar' ? home.request_title?.ar : home.request_title?.en;
  const requestDescription = locale === 'ar' ? home.request_description?.ar : home.request_description?.en;

  const safeHomeInfoTexts = Array.isArray(home.info_text) ? [...home.info_text].reverse() : [];

  return (
    <main className="bg-[#F5F6FA] pb-24">
      <div className="pt-4 home-slider">
        <PersonalizationSection
          title={locale === 'ar' ? home.personalization_title?.ar : home.personalization_title?.en}
          description={locale === 'ar' ? home.personalization_description?.ar : home.personalization_description?.en}
          subtitle={locale === 'ar' ? home.personalization_subtitle?.ar : home.personalization_subtitle?.en}
        />
      </div>
      
      <div className="info-section bg-[#00214D1A] mt-2 mb-4 lg:mb-6 lg:grid lg:grid-cols-4 lg:gap-2 container-fluid mx-auto md:py-4">
        {safeHomeInfoTexts.map((info_text: any, index: number) => {
          const infoTitle = locale === 'ar' ? info_text.title?.ar : info_text.title?.en;
          const infoDescription = locale === 'ar' ? info_text.description?.ar : info_text.description?.en;
          
          return (
            <div
              key={index}
              className="info-box flex flex-col md:flex-row justify-center items-center md:justify-start"
              dir={locale === 'ar' ? 'rtl' : 'ltr'}>
              <div className="info-image md:basis-3/12">
                <Image
                  src={
                    process.env.NEXT_PUBLIC_SITE_URL +
                    '/storage/' +
                    info_text.image
                  }
                  alt="info-image"
                  width={200}
                  height={200}
                  className="w-full"
                />
              </div>
              <div className={`info-text text-center md:basis-3/4 ${locale === 'ar' ? 'md:text-right md:mr-4' : 'md:text-left md:ml-4'}`} dir={locale === 'ar' ? 'rtl' : 'ltr'}>
                <h3 className="mt-3 text-lg font-semibold">
                  {infoTitle}
                </h3>
                <p className="text-text-color font-light text-color mt-2">
                  {infoDescription}
                </p>
              </div>
            </div>
          )
        })}
      </div>

      <div className="kingstore-banner py-4 pb-0 md:pb-6">
        <div className="container-fluid mx-auto outside-container">
          <Link href="#">
            <Image
              src={locale === 'ar' ? BannerDesk : BannerDeskEnglish}
              alt="info-image"
              width={locale === 'ar' ? BannerDesk.width : BannerDeskEnglish.width}
              height={locale === 'ar' ? BannerDesk.height : BannerDeskEnglish.height}
              className="w-full rounded-lg hidden md:block"
            />
            <Image
              src={locale === 'ar' ? BannerMobile : BannerMobileEnglish}
              alt="info-image"
              width={locale === 'ar' ? BannerMobile.width : BannerMobileEnglish.width}
              height={locale === 'ar' ? BannerMobile.height : BannerMobileEnglish.height}
              className="w-full rounded-lg md:hidden"
            />
          </Link>
        </div>
      </div>

      <PersonalizedNotebookBanner />
      <MostSoldProducts />
      <PersonalizedNotebooks personalized_notebooks={personalized_notebooks} />
      <AgeGroups age_group_options={age_group_options} />
      <FeaturedProducts most_sold_products={most_sold_products} />
      <FeaturedCategories featured_categories={featured_categories} />
      
      <div className={`container-fluid section mt-12 py-12 pb-6 flex flex-col-reverse lg:flex-row ${locale === 'ar' ? 'justify-around' : 'justify-center'} items-center`} dir={locale === 'ar' ? 'rtl' : 'ltr'}>
        <div className="w-[100%] p-4 mt-6 lg:w-[50%] 2xl:w-[40%] object-contain" dir={locale === 'ar' ? 'rtl' : 'ltr'}>
          <div className="flex ">
            <div className={`relative ${locale === 'ar' ? 'w-[70%]' : 'ml-20 w-[80%]'}`}>
              <Image
                src={Ellipse}
                alt="main-bg-ellipse"
                className="relative z-0"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={LightLogo}
                alt="Logo"
                className="absolute w-[40%] top-[15%] right-[30%] z-1"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={VectorWhite}
                alt="vector white"
                className="absolute w-[55%] top-[30%] right-[15%] z-1"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={PinkVector}
                alt="Pink vector"
                className="absolute w-[55%] top-[10%] -left-[35%] z-1"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={GreenVector}
                alt="green vector"
                className="absolute w-[90%] top-[37%] -left-[25%] z-2"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={FormBoy}
                alt="Form Boy"
                className="absolute w-[45%] top-[35%] z-3 right-[30%]"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={FormGirl}
                alt="form Girl"
                className="absolute w-[50%] top-[13%] -left-[25%] z-3"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={BookGirl}
                alt="Book Girl"
                className="absolute w-[55%] top-[33%] -left-[25%] z-4"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={BookBoy}
                alt="Book Boy"
                className="absolute w-[60%] top-[55%] z-4 right-[10%]"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={locale === 'ar' ? FormHeadingOne : contactHeading}
                alt="Form Heading one"
                className="absolute w-[30%] top-[70%] left-[5%] z-5"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={locale === 'ar' ? FormHeadingTwo : supportHeading}
                alt="Form Heading Two"
                className="absolute w-[45%] top-[83%] -left-[12%] z-5"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={LargeFormVector}
                alt="Large FOrm Vector"
                className="absolute w-[13%] top-[75%] -left-[39%] z-auto"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={MediuFormVector}
                alt="Medium form Vector"
                className="absolute w-[9%] top-[83%] -left-[33%] z-auto"
                loading="lazy"  // Add this
                priority={false}
              />
              <Image
                src={SmallFormVector}
                alt="Small Form Vector"
                className="absolute w-[5%] top-[89%] -left-[28%] z-auto"
                loading="lazy"  // Add this
                priority={false}
              />
            </div>
          </div>
        </div>

        {/* Pass only the specific localized values instead of the entire home object */}
        <HomeRequestForm 
          title={requestTitle}
          description={requestDescription}
        />
      </div>
    </main>
  )
}